import { useParams, Link } from "react-router-dom";
import Seo from "../components/common/Seo";
import { Reveal } from "../components/common/Reveal";
import Cta from "../components/common/Cta";
import { insights } from "../lib/content";
import NotFound from "./NotFound";

export default function InsightArticle() {
  const { slug } = useParams();
  const post = insights.find((p) => p.slug === slug);
  if (!post) return <NotFound />;

  return (
    <>
      <Seo title={`${post.title} — Kratos Insights`} description={post.excerpt} path={`/insights/${post.slug}`} />
      <article className="relative pt-36 md:pt-44 pb-24 kv-radial" data-testid="insight-article">
        <div className="absolute inset-0 kv-grid-bg opacity-20" aria-hidden />
        <div className="relative max-w-3xl mx-auto px-6 md:px-12">
          <Link to="/insights" className="kv-link font-mono text-[11px] uppercase tracking-[0.16em] text-kv-steel">← All insights</Link>
          <div className="mt-8 font-mono text-[10px] uppercase tracking-[0.18em] text-kv-royal">{post.category}</div>
          <Reveal>
            <h1 className="mt-4 font-display text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-[1.05] text-kv-off text-balance">{post.title}</h1>
          </Reveal>
          <p className="mt-6 font-body text-lg text-kv-grey leading-relaxed">{post.excerpt}</p>

          <div className="mt-12 border-t border-kv-steel/20 pt-10">
            <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-kv-steel mb-6">Draft outline</div>
            <ol className="space-y-5">
              {post.outline.map((point, i) => (
                <li key={i} className="flex items-start gap-4">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-kv-royal shrink-0" aria-hidden />
                  <span className="font-display text-lg md:text-xl tracking-tight text-kv-off leading-snug">{point}</span>
                </li>
              ))}
            </ol>
            <p className="mt-10 font-body text-sm text-kv-steel">Full article coming soon. This is a working outline — no unsupported claims or invented research.</p>
          </div>

          <div className="mt-12">
            <Cta to="/contact" testId="insight-cta" arrow>Book a Strategy Call</Cta>
          </div>
        </div>
      </article>
    </>
  );
}
